import { motion } from 'framer-motion'

// Components
import { EmptyState } from '@tracklib/kit'

// Utils
import { pageVariants } from 'components/interestform/utils'
import { getYoutubeIdFromUrl } from '@constants'

import styles from './videos.css'

const videoUrls = ['https://www.youtube.com/watch?v=B4aVZxtoKhU', 'https://www.youtube.com/watch?v=iBG2wv_Oook']

const Videos = (): JSX.Element => {
  return (
    <motion.div className={styles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <h1 className={styles.heading}>Videos explaining Tracklib</h1>
      <div className={styles.videosWrapper}>
        {videoUrls.map(videoUrl => {
          const id = getYoutubeIdFromUrl(videoUrl)

          if (!id) {
            return <EmptyState text="Can't load video" emoji="sad" />
          }

          return (
            <div key={id} className={styles.videoWrapper}>
              <div className={styles.videoAspectRatio}>
                <iframe
                  title={`youtube-${id}`}
                  src={`https://www.youtube.com/embed/${id}?iv_load_policy=3&playsinline=1`}
                  frameBorder="0"
                  allowFullScreen
                />
              </div>
            </div>
          )
        })}
      </div>
    </motion.div>
  )
}

export default Videos
